/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgFluentIconExcel = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10 0H4a1.003 1.003 0 0 0-1 1v3l7.001 4L13 9.968 16 8V4z",
        fill: "#21a366"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#107c41",
        d: "M16 8H3v4l7 1.4 6-1.4V8z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3 12v3a1.003 1.003 0 0 0 1 1h11a1 1 0 0 0 1-1v-3z",
        fill: "#185c37"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 4H3v10h6a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("rect", {
        y: 3,
        width: 10,
        height: 10,
        rx: 1,
        fill: "#107c41"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m2.292 11 1.942-3.008L2.455 5h1.431l.971 1.912q.134.272.184.406h.013q.096-.217.2-.423L6.293 5h1.314L5.782 7.975 7.652 11H6.255L5.133 8.9A1.753 1.753 0 0 1 5 8.62h-.016a1.324 1.324 0 0 1-.13.271L3.698 11z",
        fill: "#fff"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16 1v3h-6V0h5a1.003 1.003 0 0 1 1 1z",
        fill: "#33c481"
    }));
export default SvgFluentIconExcel;
